import React, { useMemo, useState } from 'react'
import BiztantuLoader from '../../Components/Loader'
import { Box, Button, Stack, Typography } from '@mui/material'
import { handleValidateCodevalue, userStatus } from '../../Utility/constant'
import DataGridTable from '../../Components/DataGrid'
import { useEmailConfig, getEmailConfigColumns, FolderSelectDropdown } from '../../Components/EmailConfig'
import { StyledConfigurationContainer, StyledFlexStart, StyledLeadContainer, StyledSubHeader } from '../../Components/Styled'
import { useDispatch, useSelector } from 'react-redux'
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action'
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet'
import { createRequestData } from '../../Utility/apiHelper'
import LeadDialog from '../../Components/LeadDialog'
import { useSnackbar } from 'notistack'
import '../Template/template.css';

const EMAIL_TYPE_FROM = 'FROM';
const EMAIL_TYPE_REPLY_TO = 'REPLY_TO';

const EmailSettings = () => {
    const dispatch = useDispatch();
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const ownerList = useSelector(state => state?.owner?.ownerlist);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const hasManagePermissions = (specificRolePermission?.isNotificationManage &&(specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage))
    const [selectedUser,setSelectedUser] = useState(
        hasManagePermissions
        ?   null
        : {
            firstName: currentUser.firstname || '',
            lastName: currentUser.lastname || '',
            id: currentUser.userId || null,
        }
    );
    const {
        isLoading,
        internationalise,
        fromDataGridData,
        fromRowModesModel,
        handleFromEditClick,
        handleFromSaveClick,
        handleFromCancelClick,
        processFromRowUpdate,
        replyToDataGridData,
        replyToRowModesModel,
        handleReplyToEditClick,
        handleReplyToSaveClick,
        handleReplyToCancelClick,
        replyToSelectedFolders,
        replyToAvailableFolders,
        replyToFoldersLoading,
        handleReplyToFolderChange,
        processReplyToIMapRowUpdate,
        saveReplyToImapConfig,
        isEditReplyToPage,
        isEditFromPage
    } = useEmailConfig({
        getUrl : `api/users/email-config/user/${selectedUser?.id}`,
        saveUrl : `api/users/email-config/user/${selectedUser?.id}`,
        fromType: EMAIL_TYPE_FROM,
        replyToType: EMAIL_TYPE_REPLY_TO,
        selectedUser : selectedUser,
    });

    const fromColumns = getEmailConfigColumns({
        rowModesModel: fromRowModesModel,
        handleEditClick: handleFromEditClick,
        handleSaveClick: handleFromSaveClick,
        handleCancelClick: handleFromCancelClick,
        internationalise,
        canEdit: (hasManagePermissions&& selectedUser),
    });

    const replyToColumns = getEmailConfigColumns({
        rowModesModel: replyToRowModesModel,
        handleEditClick: handleReplyToEditClick,
        handleSaveClick: handleReplyToSaveClick,
        handleCancelClick: handleReplyToCancelClick,
        internationalise,
        isIMap: true,
        canEdit: (hasManagePermissions&& selectedUser),
    });

    const handleSaveReplyToConfig = async () => {
        dispatch(requestShowLoader());
        await saveReplyToImapConfig();
        dispatch(requestHideLoader());
    };

    const handleSaveForAllUsers = async() => {
        try{
        const url = `${process.env.REACT_APP_BASE_URL}api/users/email-config/apply-to-all/${selectedUser?.id}`
        dispatch(requestShowLoader());
        const payload = {
        }
        const response = await createRequestData(payload,url);
        if(response?.status >= 200 || response?.status <= 300){
        setOpenSetForAllDialog(false)
        enqueueSnackbar(handleValidateCodevalue(internationalise,"EMAIL_MSG_SMTP_SAVED_FOR_ALL"), {variant: 'success'});
        }
        else{
            enqueueSnackbar(handleValidateCodevalue(internationalise,response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
        }
    }
    catch(error){
    
    }
    finally{
        dispatch(requestHideLoader());
    }
    }

    const handleSelectUser=(event,value)=>{
    setSelectedUser(value)
   }
   const [openSetForAllDialog,setOpenSetForAllDialog] = useState(false)

    const activeUsers = useMemo(() => (ownerList || []).filter(
            item => item?.status === userStatus.USER_STATUS_ACTIVE
        ),
        [ownerList]
    );
    return (
        <BiztantuLoader isChildren={true} open={isLoading || replyToFoldersLoading}>
             <StyledLeadContainer>
                <StyledConfigurationContainer className="email-settings-header">
                <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise, 'EMAIL_SETTINGS_TITLE')}
                </Typography>
            </StyledConfigurationContainer>
            </StyledLeadContainer>
            <Box className="email-settings-content globalBox">
                {/* FROM Address Section */}
              
                <Stack direction="column" alignItems="flex-start" className="email-settings-user-select">
                <StyledSubHeader className="email-settings-user-heading">
                    {handleValidateCodevalue(internationalise, 'SELECT_USER_TO_CONFIG_EMAIL')}
                </StyledSubHeader>
              <AutoCompleteComponent
                              className="email-settings-user-autocomplete"
                              required={true}
                              isOwner={true}
                              optionSet={activeUsers}
                              value={selectedUser}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              disabled={!hasManagePermissions}
                              name="ownerId"
                              placeholder={handleValidateCodevalue(internationalise, 'COMMON_SELECT_USER')}
                              label={handleValidateCodevalue(internationalise, 'SELECT_USER_TO_CONFIG_EMAIL')}
                              onChange={(event,value)=>handleSelectUser(event,value)}
                          />
                </Stack>
                <StyledSubHeader className="email-settings-section-heading">
                    {handleValidateCodevalue(internationalise, 'PROF_FROM_TITLE')}
                </StyledSubHeader>
                <DataGridTable
                    height ='110px' 
                    rowModesModel={fromRowModesModel} 
                    columns = {fromColumns}
                    isRequiredToolBar={false}
                    isCheckboxReq = {false}
                    dataGridData={fromDataGridData}
                    handleProcessRowUpdate={processFromRowUpdate}
                    hideFooter={true}
                />

                {/* REPLY-TO Address Section */}
               <StyledFlexStart>
               <StyledSubHeader className="email-settings-section-heading">
                        {handleValidateCodevalue(internationalise, 'PROF_REPLY_TO_TITLE')}
                    </StyledSubHeader>
                    </StyledFlexStart>
                
                <DataGridTable
                    height ='110px' 
                    rowModesModel={replyToRowModesModel} 
                    columns = {replyToColumns}
                    isRequiredToolBar={false}
                    isCheckboxReq = {false}
                    dataGridData={replyToDataGridData}
                    handleProcessRowUpdate={(newRow, oldRow) => processReplyToIMapRowUpdate(newRow, oldRow, 'api/users/email-config')}
                    hideFooter={true}
                />

                {/* Folder Selection for Reply-To */}
                <Stack direction="row" spacing={2} alignItems="flex-end" className="email-settings-folder-row">
                    <FolderSelectDropdown
                        selectedFolders={replyToSelectedFolders}
                        availableFolders={replyToAvailableFolders}
                        foldersLoading={replyToFoldersLoading}
                        onFolderChange={handleReplyToFolderChange}
                        disabled={!replyToDataGridData?.[0]?.imapHost || !specificRolePermission?.isNotificationManage}
                        internationalise={internationalise}
                        className="email-settings-folder-select"
                    />
            {(specificRolePermission?.isNotificationManage&& replyToDataGridData?.[0]?.smtpPassword) &&
                    <Button
                        className='biztantu-sec-btn'
                        variant="contained"
                        size="small"
                        onClick={handleSaveReplyToConfig}
                        disabled={!replyToDataGridData?.[0]?.imapHost}
                    >
                        {handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
                    </Button>
            }
                </Stack>
            {(specificRolePermission?.isNotificationManage 
                && isEditReplyToPage 
                &&isEditFromPage

            ) &&
                <>
                 <StyledSubHeader className = "mt-20">
                    {handleValidateCodevalue(internationalise, 'ES_SET_CRED_FOR_ALL_USERS_TITLE')}
                </StyledSubHeader>
                <Stack direction="row"  margin = {0}  spacing={3} alignItems="center" className='mb-20 mt-20'>

                <Typography gutterBottom>
                    {handleValidateCodevalue(internationalise, 'ES_SET_CRED_FOR_ALL_USERS_MSG')}
                </Typography>
                <Button
                        className='biztantu-sec-btn'
                        variant="contained"
                        size="small"
                        onClick={()=>setOpenSetForAllDialog(true)}
                    >
                        {handleValidateCodevalue(internationalise, 'COMMON_YES')}
                    </Button>
                    <LeadDialog
                    open={openSetForAllDialog}
                    handleClose={()=>setOpenSetForAllDialog(false)}
                    handleSave={handleSaveForAllUsers}
                    title={handleValidateCodevalue(internationalise,"ES_SET_FOR_ALL_USERS_TITLE")}
                    size="sm"
                    btnlabel={handleValidateCodevalue(internationalise,"COMMON_YES")}
                    alternateBtnLabel={handleValidateCodevalue(internationalise,"COMMON_NO")}
                    >
                        <Typography gutterBottom>
                        {handleValidateCodevalue(internationalise,"ES_SET_FOR_ALL_DIALOG_CONFIRM")}
                    </Typography>
                    </LeadDialog>
                </Stack>
            </>
        }
            </Box>
        </BiztantuLoader>
    )
}

export default EmailSettings